/* eslint-disable no-undef */
import React from "react";
import ReactDOM from "react-dom/client";
// import Amplify, { Auth } from "aws-amplify";
import App from "./App";
import { Provider } from "react-redux";
import { PersistGate } from "redux-persist/integration/react";
import { BrowserRouter } from "react-router-dom";
import configureStore from "./store";
import { setupXGrid } from "./utils/xGrid";
import * as serviceWorkerRegistration from "./serviceWorkerRegistration";
import reportWebVitals from "./reportWebVitals";
import "./index.scss";
import "react-responsive-carousel/lib/styles/carousel.min.css";
import { Provider as RollbarProvider, ErrorBoundary } from "@rollbar/react";
import { configure } from "ampify";
import ReactGA from 'react-ga4';

const { persistor, store } = configureStore();

const root = ReactDOM.createRoot(document.getElementById("root"));

setupXGrid();

const rollbarConfig = {
  accessToken: process.env.REACT_APP_ROLLBAR_CONFIG,
  environment: process.env.REACT_APP_ROLLBAR_ENVIRONMENT,
};

ReactGA.initialize(process.env.REACT_APP_GOOGLE_ANALYTICS_MEASUREMENT_ID);

configure();

root.render(
  <RollbarProvider config={rollbarConfig}>
    <ErrorBoundary>
      <Provider store={store}>
        <PersistGate loading={null} persistor={persistor}>
          <BrowserRouter>
            <App />
          </BrowserRouter>
        </PersistGate>
      </Provider>
    </ErrorBoundary>
  </RollbarProvider>
);

serviceWorkerRegistration.unregister();

reportWebVitals();
